import { render, staticRenderFns } from "./MultiChoiceFilter.vue?vue&type=template&id=081845a7"
import script from "./MultiChoiceFilter.vue?vue&type=script&lang=js"
export * from "./MultiChoiceFilter.vue?vue&type=script&lang=js"
import style0 from "./MultiChoiceFilter.vue?vue&type=style&index=0&id=081845a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports